import {NgModule, CUSTOM_ELEMENTS_SCHEMA, Component} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy, Routes, RouterModule} from '@angular/router';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {AppComponent} from './app.component';
// import { AngularFirestoreModule } from '@angular/fire/firestore';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {SafeGuard, AuthGuard} from './auth.guard';
import {InAppBrowser} from '@ionic-native/in-app-browser/ngx';
import {Geolocation} from '@ionic-native/geolocation/ngx';
import {LocationAccuracy} from '@ionic-native/location-accuracy/ngx';
import {NativeGeocoder} from '@ionic-native/native-geocoder/ngx';
import {SocialSharing} from '@ionic-native/social-sharing/ngx';
import {SearchPipe} from './search.pipe';
import {BottomSheet} from './bottom.sheet';
import {WelcomeComponent} from './welcome/welcome.component';
import {InterceptorModule} from './inter.service';
import {LoginComponent} from './login/login.component';
import {IonicStorageModule} from '@ionic/storage';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServicesComponent} from './services/services.component';
import {ProfileComponent} from './profile/profile.component';
import {PolicyComponent} from './policy/policy.component';
import {ProfileDetailComponent} from './profile-detail/profile-detail.component';
import {MybookingComponent} from './mybooking/mybooking.component';
import {BookingdetailsComponent} from './bookingdetails/bookingdetails.component';
import {CustomersupportComponent} from './customersupport/customersupport.component';
import {LaunchNavigator} from '@ionic-native/launch-navigator/ngx';
import {HelpComponent} from './help/help.component';
import {InternalServicesComponent} from './internal-services/internal-services.component';
import {DailyreportComponent} from './dailyreport/dailyreport.component';
import {ServiceOfferComponent} from './service-offer/service-offer.component';
import {PopularServiceComponent} from './popular-service/popular-service.component';
import {CategoryItemsComponent} from './category-items/category-items.component';
import {OfferDetailsComponent} from './offer-details/offer-details.component';
import {FaqComponent} from './faq/faq.component';
import {FeedbackComponent} from './feedback/feedback.component';
import {Push} from '@ionic-native/push/ngx';
import {FirebaseX} from '@ionic-native/firebase-x/ngx';
import {AngularFireModule} from '@angular/fire';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {AdminComponent} from './admin/admin.component';
import {CreateAssessmentComponent} from './create-assessment/create-assessment.component';
import {AssessmentComponent} from './assessment/assessment.component';
import {CreateFeedbackComponent} from './create-feedback/create-feedback.component';
import {GetFeedbackComponent} from './get-feedback/get-feedback.component';
import {VendoraddressComponent} from './vendoraddress/vendoraddress.component';
import {RatingModule, StarRatingComponent} from 'ng-starrating';
import {MapComponent} from './map/map.component';
import {FooterComponent} from './footer/footer.component';
import {AboutComponent} from './about/about.component';
import {File as FileI} from '@ionic-native/file/ngx';
import {FileOpener} from '@ionic-native/file-opener/ngx';
import {GoogleChart} from './google';
import {InvoiceComponent} from './invoice/invoice.component';
import {PaymentComponent} from './payment/payment.component';
import {DeclarationComponent} from './declaration/declaration.component';
import {AddSubscriptionComponent} from './add-subscription/add-subscription.component';
import {MaterialModule} from './material.module';
import {CustomercareComponent} from './customercare/customercare.component';
import {VendorCategoryComponent} from './vendor-category/vendor-category.component';
import {VendorDetailsComponent} from './vendor-details/vendor-details.component';
import {CustItemComponent} from './cust-item/cust-item.component';
import {CreateCustItemComponent} from './create-cust-item/create-cust-item.component';
import {VendorProfileComponent} from './vendor-profile/vendor-profile.component';
import {DocumentsComponent} from './documents/documents.component';
import {AwardsComponent} from './awards/awards.component';
import {AddBankDetailsComponent} from './add-bank-details/add-bank-details.component';
import {BankDetailsComponent} from './bank-details/bank-details.component';
import {ManageUserComponent} from './manage-user/manage-user.component';
import {ManageCustomerComponent} from './manage-customer/manage-customer.component';
import {ManageServicesComponent} from './manage-services/manage-services.component';
import {ViewMapComponent} from './view-map/view-map.component';
import {VendorProfileViewComponent} from './vendor-profile-view/vendor-profile-view.component';
import {VendorApprovalComponent} from './vendor-approval/vendor-approval.component';
import {CustomerProfileComponent} from './customer-profile/customer-profile.component';
import {CreateServiceComponent} from './create-service/create-service.component';
import {CreateCategoryComponent} from './create-category/create-category.component';
import {MyAssignmentsComponent} from './my-assignments/my-assignments.component';
import {RequestsComponent} from './requests/requests.component';
import {RegisterComponent} from './register/register.component';
import {AllSubscriptionComponent} from './all-subscription/all-subscription.component';
import {AdminRegComponent} from './admin-reg/admin-reg.component';
import {CreateSubscriptionComponent} from './create-subscription/create-subscription.component';
import {ManageSubscriptionsComponent} from './manage-subscriptions/manage-subscriptions.component';
import {VendorLoginComponent} from './vendor-login/vendor-login.component';
import {VendorValidateComponent} from './vendor-validate/vendor-validate.component';
import {ApprovalDetailsComponent} from './approval-details/approval-details.component';
import {Camera} from '@ionic-native/camera/ngx';
import {NewpwdComponent} from './newpwd/newpwd.component';
import {CreateCustSubscriptionComponent} from './create-cust-subscription/create-cust-subscription.component';
import {OrgProfileComponent} from './org-profile/org-profile.component';
import {VendorRegisterComponent} from './vendor-register/vendor-register.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {AssignVendorComponent} from './assign-vendor/assign-vendor.component';
import {AccountValidateComponent} from './account-validate/account-validate.component';
import {AssignEmployeeComponent} from './assign-employee/assign-employee.component';
import {ManageOrgsComponent} from './manage-orgs/manage-orgs.component';
import {VendorRequestComponent} from './vendor-request/vendor-request.component';
import {SetupComponent} from './setup/setup.component';
import {ManageRoleComponent} from './manage-role/manage-role.component';
import {CreateRoleComponent} from './create-role/create-role.component';
import {TagRolesComponent} from './tag-roles/tag-roles.component';
import {SettingsComponent} from './settings/settings.component';
import {VendorSubscriptionsComponent} from './vendor-subscriptions/vendor-subscriptions.component';
import {CreateSingleRequestComponent} from './create-single-request/create-single-request.component';
import {SatDatepickerModule, SatNativeDateModule} from 'saturn-datepicker';
import {InappRegComponent} from './inapp-reg/inapp-reg.component';
import {ManageRequestComponent} from './manage-request/manage-request.component';
import {ManageInvoiceComponent} from './manage-invoice/manage-invoice.component';
import {DetailedInvoiceComponent} from './detailed-invoice/detailed-invoice.component';
import {ApprovalorgDetailsComponent} from './approvalorg-details/approvalorg-details.component';
import {HeaderComponent} from './header/header.component';
import {TagCategoryComponent} from './tag-category/tag-category.component';
import {ViewItemsComponent} from './view-items/view-items.component';
import {AdsCreateComponent} from './ads-create/ads-create.component';
import {AdsComponent} from './ads/ads.component';
import {AdsOrgComponent} from './ads-org/ads-org.component';
import {RewardsrefComponent} from './rewardsref/rewardsref.component';
import {RewardsComponent} from './rewards/rewards.component';
import {RewardDetailsComponent} from './reward-details/reward-details.component';
import {ReferEarnDashComponent} from './refer-earn-dash/refer-earn-dash.component';
import {AddReferralComponent} from './add-referral/add-referral.component';
import {ReferProviderComponent} from './refer-provider/refer-provider.component';
import {ShareOrgComponent} from './share-org/share-org.component';
import {ReferralsListComponent} from './referrals-list/referrals-list.component';
import {AssoServiceComponent} from './asso-service/asso-service.component';
import {ReviewInvoiceComponent} from './review-invoice/review-invoice.component';
import {ManageOndemandReqComponent} from './manage-ondemand-req/manage-ondemand-req.component';
import {MonthlyTrackerComponent} from './monthly-tracker/monthly-tracker.component';
import {CreateSettlementInvoiceComponent} from './create-settlement-invoice/create-settlement-invoice.component';
import {Diagnostic as Diagnostics} from '@ionic-native/diagnostic/ngx';
import {GroupOnDemendReqComponent} from './group-on-demend-req/group-on-demend-req.component';
import {Search1Pipe} from './search1.pipe';
import {Keyboard} from '@ionic-native/keyboard/ngx';
import {CustomerRegComponent} from './customer-reg/customer-reg.component';
import {PageScrollDirective} from './page-scroll.directive';
import {CustomerServiceBookingComponent} from './customer-service-booking/customer-service-booking.component';
import {CreateCustProfileComponent} from './create-cust-profile/create-cust-profile.component';
import {
    CustomerSubscriptionBookingComponent
} from './customer-subscription-booking/customer-subscription-booking.component';
import {CalendarComponent} from './calendar/calendar.component';
import {BlocktimerComponent} from './blocktimer/blocktimer.component';
import {BlockEndComponent} from './block-end/block-end.component';
import {CalendarManageComponent} from './calendar-manage/calendar-manage.component';
import {TimepickerComponent} from './timepicker/timepicker.component';
import {PaymentOptionsComponent} from './payment-options/payment-options.component';
import {WebIntent} from '@ionic-native/web-intent/ngx';
import {AppAvailability} from '@ionic-native/app-availability/ngx';
import {MatTableModule} from '@angular/material/table';
import {ManageBrandsComponent} from './manage-brands/manage-brands.component';
import {CreateBrandComponent} from './create-brand/create-brand.component';
import {ManageProductComponent} from './manage-product/manage-product.component';
import {CreateProductComponent} from './create-product/create-product.component';
import {ManageItemsComponent} from './manage-items/manage-items.component';
import {ManageItemCategoryComponent} from './manage-item-category/manage-item-category.component';
import {ReviewItemsComponent} from './review-items/review-items.component';
import {CreateitemComponent} from './createitem/createitem.component';
import {ManagePromotionsComponent} from './manage-promotions/manage-promotions.component';
import {CreatePromotionsComponent} from './create-promotions/create-promotions.component';
import {from} from 'rxjs';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ManageOrdersComponent} from './manage-orders/manage-orders.component';
import {OrderRequestComponent} from './order-request/order-request.component';
import {BillingsComponent} from './billings/billings.component';
import {ManageSizeComponent} from './manage-size/manage-size.component';
import {CreatePurchaseCategoryComponent} from './create-purchase-category/create-purchase-category.component';
import {CreateSizeComponent} from './create-size/create-size.component';
import {ManageColourComponent} from './manage-colour/manage-colour.component';
import {CreateColorComponent} from './create-color/create-color.component';
import {ItemPurchaseComponent} from './item-purchase/item-purchase.component';
import {SmsRetriever} from '@ionic-native/sms-retriever/ngx';
import {PurchaseInvoiceComponent} from './purchase-invoice/purchase-invoice.component';
import {CustomerPurchaseComponent} from './customer-purchase/customer-purchase.component';

import {ManagePurchaseComponent} from './manage-purchase/manage-purchase.component';
import {DeliveryComponent} from './delivery/delivery.component';

import {PurchaseItemsComponent} from './purchase-items/purchase-items.component';
import {SetLocationComponent} from './set-location/set-location.component';
import {DemoComponent} from './demo/demo.component';
import {AllInOneSDK} from '@ionic-native/all-in-one-sdk/ngx';
import {PaymentStatusComponent} from './payment-status/payment-status.component';
import {VendorOrderEditComponent} from './vendor-order-edit/vendor-order-edit.component';
import {SelectPurchaseCategoryComponent} from './select-purchase-category/select-purchase-category.component';
import {PurchaseItemsListComponent} from './purchase-items-list/purchase-items-list.component';
import {SplashComponent} from './splash/splash.component';
import {NgOtpInputModule} from 'ng-otp-input';
import {CounterDirective} from './counter.directive';
import {NewOrderComponent} from './new-order/new-order.component';
import {NewOrderCategoryComponent} from './new-order-category/new-order-category.component';
import {MyTrackerComponent} from './my-tracker/my-tracker.component';
import {CompletedOrdersComponent} from './completed-orders/completed-orders.component';
import {CompletedRequestsComponent} from './completed-requests/completed-requests.component';
import {VendorInvoiceComponent} from './vendor-invoice/vendor-invoice.component';
import {NewManageOrderComponent} from './new-manage-order/new-manage-order.component';
import {NewManageOnDemandRequestComponent} from './new-manage-on-demand-request/new-manage-on-demand-request.component';
import { VendorFilterComponent } from './vendor-filter/vendor-filter.component';
import { MembcountComponent } from './membcount/membcount.component';

var config = {
    apiKey: "AIzaSyCiuRT6pD2NlFs12CExQzVNGhPTfhGYmW4",
    authDomain: "yessboss-bc640.firebaseapp.com",
    projectId: "yessboss-bc640",
    storageBucket: "yessboss-bc640.appspot.com",
    messagingSenderId: "613106621738",
    appId: "1:613106621738:web:b8f8a2daa5ff1171525253",
    measurementId: "G-HE4LRNJX1S"
};

const routes: Routes = [
    {
        path: '', canActivate: [SafeGuard], children: [
            {path: '', redirectTo: 'set-location', pathMatch: 'full'},
            {path: 'vendor-login', component: WelcomeComponent},
            {path: 'vendorLogin', component: VendorLoginComponent},
            {path: 'bookservice', component: ServicesComponent},
            {path: 'profile', component: ProfileComponent},
            {path: 'mybookings', component: MybookingComponent},
            {path: 'customerCare', component: CustomercareComponent},
            {path: 'vendor-register', component: VendorRegisterComponent},
            {path: 'customer-reg', component: CustomerRegComponent},
            {path: 'customer-login', component: CustomerRegComponent},
            {path: 'subs-cust-register', component: CustomerRegComponent},
            {path: 'subservice', component: InternalServicesComponent},
            {path: 'subSubs/:id', component: InternalServicesComponent},
            {path: 'login', component: WelcomeComponent},
            {path: 'policy', component: PolicyComponent},
            {path: 'register', component: RegisterComponent},
            {path: 'popular', component: PopularServiceComponent},
            {path: 'offer', component: ServiceOfferComponent},
            {path: 'about', component: AboutComponent},
            {path: 'vendorCategory', component: VendorCategoryComponent},
            {path: 'choose-category', component: VendorCategoryComponent},
            {path: 'payment/:id', component: PaymentComponent},
            {path: 'help', component: HelpComponent},
            {path: 'declaration/:id', component: DeclarationComponent},
            {path: 'offer-details', component: OfferDetailsComponent},
            {path: 'faq', component: FaqComponent},
            {path: 'newpwd', component: NewpwdComponent},
            {path: 'adminReg', component: AdminRegComponent},
            {path: 'employeeReg', component: AdminRegComponent},
            {path: 'account-validate', component: AccountValidateComponent},
            {path: 'validateForOrder', component: AccountValidateComponent},
            {path: 'contractorReg', component: AccountValidateComponent},
            {path: 'validateForSubs', component: AccountValidateComponent},
            {path: 'validateForPurc', component: AccountValidateComponent},
            {path: 'validateProfile', component: AccountValidateComponent},
            {path: 'employeeCheck', component: AccountValidateComponent},
            {path: 'vendoraddress', component: VendoraddressComponent},
            {path: 'vendorValidate', component: VendorValidateComponent},
            {path: 'myrequests', component: MybookingComponent},
            {path: 'mySubscriptions', component: MybookingComponent},
            {path: 'customerProfile1', component: CustomerProfileComponent},
            {path: 'purchaserProfile', component: CustomerProfileComponent},
            {path: 'customerProfile2', component: CustomerProfileComponent},
            {path: 'editcustomerProfile1/:id', component: CustomerProfileComponent},
            {path: 'purchase-items/:id', component: ItemPurchaseComponent},
            {path: 'set-location', component: SetLocationComponent},


        ]
    },

    {
        path: '', canActivate: [AuthGuard], children: [
            {path: 'mySubscriptions1', component: MybookingComponent},
            {path: 'vendor-register1', component: VendorRegisterComponent},
            {path: 'editcustomerProfile2/:id', component: CustomerProfileComponent},
            {path: 'dailyreport/:id', component: DailyreportComponent},
            {path: 'policy1', component: PolicyComponent},
            {path: 'faq1', component: FaqComponent},
            {path: 'req-booking', component: CustomerServiceBookingComponent},
            {path: 'subs-booking', component: CustomerSubscriptionBookingComponent},
            {path: 'item-purchase', component: CustomerPurchaseComponent},
            {path: 'booking-details/:id', component: BookingdetailsComponent},
            {path: 'booking-details1/:id', component: BookingdetailsComponent},
            {path: 'purchase-items1/:id', component: ItemPurchaseComponent},
            {path: 'edit-purchase/:id', component: ItemPurchaseComponent},
            {path: 'bookservice1', component: ServicesComponent},
            {path: 'profile1', component: ProfileComponent},
            {path: 'subservice1', component: InternalServicesComponent},
            {path: 'subSubs1/:id', component: InternalServicesComponent},
            {path: 'edit-services', component: InternalServicesComponent},
            {path: 'mybookings1', component: MybookingComponent},
            {path: 'savedOrders', component: MybookingComponent},
            {path: 'myrequests1', component: MybookingComponent},
            {path: 'invoice/:id', component: InvoiceComponent},
            {path: 'order-payment', component: PaymentOptionsComponent},
            {path: 'sub-pay/:id', component: PaymentOptionsComponent},
            {path: 'payment-subs/:id', component: PaymentOptionsComponent},
            {path: 'orders-pay-options/:id', component: PaymentOptionsComponent},
            {path: 'customerCare1', component: CustomercareComponent},
            {path: 'myprofile', component: ProfileDetailComponent},
            {path: 'create-subscription/:id', component: AddSubscriptionComponent},
            {path: 'edit-subscription/:id', component: AddSubscriptionComponent},
            {path: 'customer/:id', component: CustomersupportComponent},
            {path: 'all-subscriptions', component: AllSubscriptionComponent},
            {path: 'category', component: CategoryItemsComponent},
            {path: 'create-category', component: CreateCategoryComponent},
            {path: 'edit-category/:id', component: CreateCategoryComponent},
            {path: 'org-Choose-Cate', component: VendorCategoryComponent},
            {path: 'employee-category', component: VendorCategoryComponent},
            {path: 'manager-category', component: VendorCategoryComponent},
            {path: 'cust-Req-category', component: VendorCategoryComponent},
            {path: 'cust-care-category', component: VendorCategoryComponent},
            {path: 'provider-category', component: VendorCategoryComponent},
            {path: 'supervisor-category', component: VendorCategoryComponent},
            {path: 'vendorProfile/:id', component: VendorProfileComponent},
            {path: 'vendorAdminProfile', component: VendorProfileComponent},
            {path: 'vendorDetails', component: VendorDetailsComponent},
            {path: 'custItem/:id', component: CustItemComponent},
            // { path:'custItem',component:CustItemComponent},
            {path: 'create-cust-item', component: CreateCustItemComponent},
            {path: 'cust-item-create', component: CreateCustItemComponent},
            {path: 'customerItem', component: CreateCustItemComponent},
            {path: 'edit-cust-item/:id', component: CreateCustItemComponent},
            {path: 'cust-item-edit/:id', component: CreateCustItemComponent},
            {path: 'mng-invoice', component: ManageInvoiceComponent},
            {path: 'document/:id/:id', component: DocumentsComponent},
            {path: 'document-Address/:id', component: DocumentsComponent},
            {path: 'check-Address/:id', component: DocumentsComponent},
            {path: 'document-identity/:id', component: DocumentsComponent},
            {path: 'check-document/:id', component: DocumentsComponent},
            {path: 'awards/:id', component: AwardsComponent},
            {path: 'addDetails/:id', component: AddBankDetailsComponent},
            {path: 'editDetails/:id', component: AddBankDetailsComponent},
            {path: 'bankdetails/:id', component: BankDetailsComponent},
            {path: 'feedback', component: FeedbackComponent},
            {path: 'admin', component: AdminComponent},
            {path: 'create-assessment', component: CreateAssessmentComponent},
            {path: 'assessment', component: AssessmentComponent},
            {path: 'setup', component: SetupComponent},
            {path: 'edit-assessment/:id', component: CreateAssessmentComponent},
            {path: 'create-feedback', component: CreateFeedbackComponent},
            {path: 'get-feedback', component: GetFeedbackComponent},
            {path: 'edit-feedback/:id', component: CreateFeedbackComponent},
            {path: 'user', component: ManageUserComponent},
            {path: 'inapp-Reg', component: InappRegComponent},
            {path: 'customer', component: ManageCustomerComponent},
            {path: 'vendorProfileView/:id', component: VendorProfileViewComponent},
            {path: 'vendorProfileViewUser/:id', component: VendorProfileViewComponent},
            {path: 'contractorProfileView/:id', component: VendorProfileViewComponent},
            {path: 'map/:id', component: MapComponent},
            {path: 'mngVendorAdd', component: VendoraddressComponent},
            {path: 'manageServices', component: ManageServicesComponent},
            {path: 'customerProfile', component: CustomerProfileComponent},
            {path: 'newCustomer', component: CustomerProfileComponent},
            {path: 'newCustomerService', component: CustomerProfileComponent},
            {path: 'editcustomerProfile/:id', component: CustomerProfileComponent},
            {path: 'vendor-approval', component: VendorApprovalComponent},
            {path: 'createServices', component: CreateServiceComponent},
            {path: 'edit-service/:id', component: CreateServiceComponent},
            {path: 'myAssignments', component: MyAssignmentsComponent},
            {path: 'requests', component: RequestsComponent},
            {path: 'orgRequest/:id', component: VendorRequestComponent},
            {path: 'userRequest/:id', component: RequestsComponent},
            {path: 'edit-subs/:id', component: CreateSubscriptionComponent},
            {path: 'createSubscription', component: CreateSubscriptionComponent},
            {path: 'Org-register', component: RegisterComponent},
            {path: 'manageSubscriptions', component: ManageSubscriptionsComponent},
            {path: 'org-admin', component: AdminRegComponent},
            {path: 'vendorEmpReg', component: AdminRegComponent},
            {path: 'mangerEmpReg', component: AdminRegComponent},
            {path: 'custReqEmpReg', component: AdminRegComponent},
            {path: 'custCareEmpReg', component: AdminRegComponent},
            {path: 'supervisorReg', component: AdminRegComponent},
            {path: 'assignVendor/:id', component: AssignVendorComponent},
            {path: 'orderAssign/:id', component: AssignVendorComponent},
            {path: 'changeOrderAssign/:id', component: AssignVendorComponent},
            {path: 'purchaseAssign/:id', component: AssignVendorComponent},
            {path: 'changePurchaseAssign/:id', component: AssignVendorComponent},
            {path: 'packageAssign/:id', component: AssignVendorComponent},
            {path: 'changeAssignVendor/:id', component: AssignVendorComponent},
            {path: 'changePackageAssign/:id', component: AssignVendorComponent},
            {path: 'changeAlloc/:id', component: AssignVendorComponent},
            {path: 'vendorAssign/:id', component: AssignVendorComponent},
            {path: 'changeVendorAssign/:id', component: AssignVendorComponent},
            {path: 'homeVendorAssign/:id', component: AssignVendorComponent},
            {path: 'homeChangeVendorAssign/:id', component: AssignVendorComponent},
            {path: 'contractorAssign/:id', component: AssignEmployeeComponent},
            {path: 'homeContractorAssign/:id', component: AssignEmployeeComponent},
            {path: 'manage-org', component: ManageOrgsComponent},
            {path: 'viewmap', component: ViewMapComponent},
            {path: 'cust-item-subs/:id', component: CreateCustSubscriptionComponent},
            {path: 'cust-subs-booking/:id', component: CreateCustSubscriptionComponent},
            {path: 'edit-cust-item-subs/:id', component: CreateCustSubscriptionComponent},
            {path: 'approve/:id', component: ApprovalDetailsComponent},
            {path: 'org-profile/:id', component: OrgProfileComponent},
            {path: 'profile-org/:id', component: OrgProfileComponent},
            {path: 'single-request/:id', component: CreateSingleRequestComponent},
            {path: 'single-requests/:id', component: CreateSingleRequestComponent},
            {path: 'single-request-In', component: CreateSingleRequestComponent},
            {path: 'single-booking/:id', component: CreateSingleRequestComponent},
            {path: 'assign-employee/:id', component: AssignEmployeeComponent},
            {path: 'assign-employee1/:id', component: AssignEmployeeComponent},
            {path: 'change-Alloc/:id', component: AssignEmployeeComponent},
            {path: 'change-Alloc1/:id', component: AssignEmployeeComponent},
            {path: 'packAssign-emp/:id', component: AssignEmployeeComponent},
            {path: 'manageSubAssign/:id', component: AssignEmployeeComponent},
            {path: 'orderEmpAssign/:id', component: AssignEmployeeComponent},
            {path: 'purchaseEmpAssign/:id', component: AssignEmployeeComponent},
            {path: 'AssigningEmp/:id', component: AssignEmployeeComponent},
            {path: 'vendor-request', component: VendorRequestComponent},
            {path: 'vendor-subs', component: VendorSubscriptionsComponent},
            {path: 'manage-role', component: ManageRoleComponent},
            {path: 'tag-role/:id', component: TagRolesComponent},
            {path: 'cust-role-tag/:id', component: TagRolesComponent},
            {path: 'create-role', component: CreateRoleComponent},
            {path: 'edit-role/:id', component: CreateRoleComponent},
            {path: 'approveorg/:id', component: ApprovalorgDetailsComponent},
            {path: 'manageRequest/:id', component: ManageRequestComponent},
            {path: 'vendorRequests/:id', component: ManageRequestComponent},
            {path: 'detailInvoice/:id', component: DetailedInvoiceComponent},
            {path: 'settings', component: SettingsComponent},
            {path: 'post-ad', component: AdsCreateComponent},
            {path: 'tagCategory/:id', component: TagCategoryComponent},
            {path: 'cotractorCategory/:id', component: TagCategoryComponent},
            {path: 'viewItems/:id', component: ViewItemsComponent},
            {path: 'edit-ad/:id', component: AdsCreateComponent},
            {path: 'ads', component: AdsComponent},
            {path: 'ads-org', component: AdsOrgComponent},
            {path: 'edit-ad/:id', component: AdsCreateComponent},
            {path: 'rewardsref', component: RewardsrefComponent},
            {path: 'rewards', component: RewardsComponent},
            {path: 'refer-dash', component: ReferEarnDashComponent},
            {path: 'referprovider', component: ReferProviderComponent},
            {path: 'addreferral', component: AddReferralComponent},
            {path: 'addOrgreferral', component: AddReferralComponent},
            {path: 'reward-details/:id', component: RewardDetailsComponent},
            {path: 'reward-friends', component: RewardDetailsComponent},
            {path: 'shareorg/:id', component: ShareOrgComponent},
            {path: 'asso-service/:id', component: AssoServiceComponent},
            {path: 'manage-ondemand-req', component: ManageOndemandReqComponent},
            {path: 'referal-list', component: ReferralsListComponent},
            {path: 'settlement-invoice', component: CreateSettlementInvoiceComponent},
            {path: 'review-invoice/:id', component: ReviewInvoiceComponent},
            {path: 'review-invoice-subs/:id', component: ReviewInvoiceComponent},
            {path: 'review-invoice-reqs/:id', component: ReviewInvoiceComponent},
            {path: 'monthly-Tracker', component: MonthlyTrackerComponent},
            {path: 'group-On-Demand', component: GroupOnDemendReqComponent},
            {path: 'group-On-Demand1', component: GroupOnDemendReqComponent},
            {path: 'calendar', component: CalendarComponent},
            {path: 'calendarmanage', component: CalendarManageComponent},
            {path: 'manage-brands', component: ManageBrandsComponent},
            {path: 'create-brands', component: CreateBrandComponent},
            {path: 'edit-brands/:id', component: CreateBrandComponent},
            {path: 'manage-products', component: ManageProductComponent},
            {path: 'create-product', component: CreateProductComponent},
            {path: 'edit-product/:id', component: CreateProductComponent},
            {path: 'manage-items', component: ManageItemsComponent},
            {path: 'manage-items-Category', component: ManageItemCategoryComponent},
            {path: 'review-items', component: ReviewItemsComponent},
            {path: 'saved-items/:id', component: ReviewItemsComponent},
            {path: 'record-pay/:id', component: ReviewItemsComponent},
            {path: 'pending-pay/:id', component: ReviewItemsComponent},
            {path: 'home-record-pay/:id', component: ReviewItemsComponent},
            {path: 'create-item', component: CreateitemComponent},
            {path: 'edit-item/:id', component: CreateitemComponent},
            {path: 'manage-promotions', component: ManagePromotionsComponent},
            {path: 'create-promotions', component: CreatePromotionsComponent},
            {path: 'edit-promotions/:id', component: CreatePromotionsComponent},
            {path: 'dashboard', component: DashboardComponent},
            {path: 'manage-Order', component: ManageOrdersComponent},
            {path: 'order-requests/:id', component: OrderRequestComponent},
            {path: 'manage-requests/:id', component: OrderRequestComponent},
            {path: 'purchase-ItemsList/:id', component: PurchaseItemsComponent},
            {path: 'con-requests/:id', component: OrderRequestComponent},
            {path: 'billings/:id', component: BillingsComponent},
            {path: 'create-purchaseCategory', component: CreatePurchaseCategoryComponent},
            {path: 'edit-purchaseCategory/:id', component: CreatePurchaseCategoryComponent},
            {path: 'manage-size', component: ManageSizeComponent},
            {path: 'create-size', component: CreateSizeComponent},
            {path: 'edit-size/:id', component: CreateSizeComponent},
            {path: 'delivery', component: DeliveryComponent},
            {path: 'manage-color', component: ManageColourComponent},
            {path: 'demo', component: DemoComponent},
            {path: 'create-color', component: CreateColorComponent},
            {path: 'edit-color/:id', component: CreateColorComponent},
            {path: 'purchase-invoice/:id', component: PurchaseInvoiceComponent},
            {path: 'manage-purchase', component: ManagePurchaseComponent},
            {path: 'success', component: PaymentStatusComponent},
            {path: 'failure', component: PaymentStatusComponent},
            {path: 'PASS', component: PaymentStatusComponent},
            {path: 'FAIL', component: PaymentStatusComponent},
            {path: 'pending', component: PaymentStatusComponent},
            {path: 'vendor-order-edit/:id', component: VendorOrderEditComponent},
            {path: 'initial-order-edit/:id', component: VendorOrderEditComponent},
            {path: 'contractor-order-edit/:id', component: VendorOrderEditComponent},
            {path: 'home-order-edit/:id', component: VendorOrderEditComponent},
            {path: 'contractor-Purchase-category', component: SelectPurchaseCategoryComponent},
            {path: 'vendor-Purchase-category', component: SelectPurchaseCategoryComponent},
            {path: 'Contractor-Items/:id', component: PurchaseItemsListComponent},
            {path: 'Vendor-Items/:id', component: PurchaseItemsListComponent},
            {path: 'regCont', component: AccountValidateComponent},
            {path: 'newCategories', component: NewOrderCategoryComponent},
            {path: 'vendor-new-order/:id', component: NewOrderComponent},
            {path: 'contracter-new-order/:id', component: NewOrderComponent},
            {path: 'createNewOrder/:id', component: NewOrderComponent},
            {path: 'homeNewOrder/:id', component: NewOrderComponent},
            {path: 'mytracker', component: MyTrackerComponent},
            {path: 'completedOrder', component: CompletedOrdersComponent},
            {path: 'completedRequest', component: CompletedRequestsComponent},
            {path: 'vendorProfile1/:id', component: VendorProfileComponent},
            {path: 'vendor-invoice/:id', component: VendorInvoiceComponent},
            {path: 'home-Vendor-invoice/:id', component: VendorInvoiceComponent},
            {path: 'admin-manage-order', component: NewManageOrderComponent},
            {path: 'vendor-manage-order', component: NewManageOrderComponent},
            {path: 'newOndemand', component: NewManageOnDemandRequestComponent},
            {path: 'homeCategories', component: NewOrderCategoryComponent},
            {path: 'home-new-order/:id', component: NewOrderComponent},
            {path: 'vendor-filter', component: VendorFilterComponent},
            {path: 'membcount', component: MembcountComponent},
            {path: '', redirectTo: 'bookservice', pathMatch: 'full'},
            {path: '**', redirectTo: 'bookservice', pathMatch: 'full'}
        ]
    },


];

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AdsCreateComponent,
        AccountValidateComponent,
        CreateRoleComponent,
        ManageRoleComponent,
        CreateCustItemComponent,
        CustItemComponent,
        CreateCategoryComponent,
        VendorApprovalComponent,
        ManageServicesComponent,
        VendoraddressComponent,
        GetFeedbackComponent,
        CreateFeedbackComponent,
        AssessmentComponent,
        CreateAssessmentComponent,
        ManageInvoiceComponent,
        AdminComponent,
        MapComponent,
        AppComponent,
        SetupComponent,
        SearchPipe,
        GoogleChart,
        NewpwdComponent,
        AdminRegComponent,
        VendorRegisterComponent,
        ApprovalDetailsComponent,
        CreateCustProfileComponent,
        PurchaseItemsListComponent,
        CreateBrandComponent,
        ProfileComponent,
        WelcomeComponent,
        RegisterComponent,
        DeclarationComponent,
        LoginComponent,
        ServicesComponent,
        InappRegComponent,
        ProfileComponent,
        VendorProfileViewComponent,
        CreateServiceComponent,
        VendorOrderEditComponent,
        ManageSubscriptionsComponent,
        CreateSubscriptionComponent,
        ManageItemsComponent,
        NewManageOrderComponent,
        PolicyComponent,
        FooterComponent,
        InvoiceComponent,
        ManageOndemandReqComponent,
        DemoComponent,
        ManageUserComponent,
        CustomerProfileComponent,
        ManageCustomerComponent,
        DeliveryComponent,
        PaymentComponent,
        PaymentOptionsComponent,
        TagCategoryComponent,
        AboutComponent,
        VendorLoginComponent,
        SetLocationComponent,
        RequestsComponent,
        MyAssignmentsComponent,
        DailyreportComponent,
        DocumentsComponent,
        BankDetailsComponent,
        AddBankDetailsComponent,
        AllSubscriptionComponent,
        AwardsComponent,
        AddSubscriptionComponent,
        CustomerPurchaseComponent,
        MybookingComponent,
        VendorValidateComponent,
        PopularServiceComponent,
        ServiceOfferComponent,
        CustomercareComponent,
        CustomersupportComponent,
        ManagePurchaseComponent,
        ProfileDetailComponent,
        FaqComponent,
        FeedbackComponent,
        InternalServicesComponent,
        HelpComponent,
        CreateCustSubscriptionComponent,
        BookingdetailsComponent,
        CategoryItemsComponent,
        VendorCategoryComponent,
        VendorDetailsComponent,
        VendorProfileComponent,
        VendorSubscriptionsComponent,
        ViewMapComponent,
        AssignVendorComponent,
        CreateSingleRequestComponent,
        OrgProfileComponent,
        ManageOrgsComponent,
        AssignEmployeeComponent,
        VendorRequestComponent,
        ApprovalorgDetailsComponent,
        NewManageOnDemandRequestComponent,
        TagRolesComponent,
        SettingsComponent,
        DetailedInvoiceComponent,
        ManageRequestComponent,
        HeaderComponent,
        ViewItemsComponent,
        AdsOrgComponent,
        AdsComponent,
        RewardsrefComponent,
        RewardsComponent,
        RewardDetailsComponent,
        ReferEarnDashComponent,
        AddReferralComponent,
        ReferProviderComponent,
        ShareOrgComponent,
        ReferralsListComponent,
        AssoServiceComponent,
        ReviewInvoiceComponent,
        MonthlyTrackerComponent,
        CreateSettlementInvoiceComponent,
        GroupOnDemendReqComponent,
        CustomerServiceBookingComponent,
        CustomerSubscriptionBookingComponent,
        CustomerRegComponent,
        ItemPurchaseComponent,
        CalendarComponent,
        VendorInvoiceComponent,
        BlocktimerComponent,
        BlockEndComponent,
        CalendarManageComponent,
        TimepickerComponent,
        ManageBrandsComponent,
        ManageProductComponent,
        CreateProductComponent,
        ManageItemCategoryComponent,
        CreatePurchaseCategoryComponent,
        ReviewItemsComponent,
        CreateitemComponent,
        ManagePromotionsComponent,
        CreatePromotionsComponent,
        DashboardComponent,
        ManageOrdersComponent,
        NewOrderCategoryComponent,
        BillingsComponent,
        ManageSizeComponent,
        NewOrderComponent,
        PurchaseItemsComponent,
        SplashComponent,
        BottomSheet,
        Search1Pipe,
        CreateSizeComponent,
        OrderRequestComponent,
        ManageColourComponent,
        CreateColorComponent,
        PurchaseInvoiceComponent,
        PageScrollDirective,
        MyTrackerComponent,
        CompletedOrdersComponent,
        PaymentStatusComponent,
        CompletedRequestsComponent,
        SelectPurchaseCategoryComponent,
        CounterDirective,
        VendorFilterComponent,
        MembcountComponent

    ],
    entryComponents: [BottomSheet, TimepickerComponent, SplashComponent],
    imports: [
        NgOtpInputModule,
        RatingModule,
        BrowserModule,
        HttpClientModule,
        AngularEditorModule,
        BrowserAnimationsModule,
        InterceptorModule,
        FormsModule,
        MaterialModule,
        MatTableModule,
        RatingModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        AngularFirestoreModule,
        SatDatepickerModule,
        SatNativeDateModule,
        IonicStorageModule.forRoot(),
        IonicModule.forRoot(),
        AngularFireModule.initializeApp(config),
        AngularFireDatabaseModule,
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireStorageModule,
        RouterModule.forRoot(routes, {useHash: true}),
        TranslateModule.forRoot({
            defaultLanguage: 'en-US',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    bootstrap: [AppComponent],
    providers: [
        StatusBar,
        InAppBrowser,
        Geolocation,
        NativeGeocoder,
        LaunchNavigator,
        FileI,
        Push,
        FileOpener,
        Camera,
        SocialSharing,
        LocationAccuracy,
        LaunchNavigator,
        Keyboard,
        WebIntent,
        AppAvailability,
        Diagnostics,
        SplashScreen,
        SmsRetriever,
        AllInOneSDK,
        FirebaseX,
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy}
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class AppModule {
}
